<h2 mat-dialog-title>Day ski sweeps or night ski sweeps?</h2>
<mat-dialog-actions align="center">
    <img class="img-buttons" (click)="dialogRef.close('Day')" src="../../../../assets/day-sweeps.jpg">
    <img class="img-buttons" (click)="dialogRef.close('Night')" src="../../../../assets/night-sweeps.jpg">
  </mat-dialog-actions>